export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" data-testid="logo-mark">
    <rect width="64" height="64" fill="#102B3F" />
    <path d="M13 15l9.5 25L32 22l9.5 18L51 15" fill="none" stroke="#F4EFE6" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 50c5-4.5 9-4.5 14 0s9 4.5 14 0 9-4.5 14 0" fill="none" stroke="#C65842" strokeWidth="4" strokeLinecap="round" />
  </svg>
);
